// extracted by mini-css-extract-plugin
export default {"root":"PageContainer_root__MROKI"};